import API from "../Services/API";
import Model from "./Model";

const features = {
    ADDITIONAL_USERS       : 'Additional Users',
    ADVANCED_SCHEDULING    : 'Advanced Scheduling',
    AI_ASSISTANT           : 'AI Assistant',
    ATTACHMENTS            : 'Attachments',
    AUTO_REPLY             : 'Auto Reply',
    BANK_RECONCILIATION    : 'Bank Reconciliation',
    BASIC_WEBSITE          : 'Website',
    BROADCASTS             : 'Broadcasts',
    CARDS_PAYMENTS         : 'Card Payments',
    CUSTOM_DOMAIN          : 'Custom Domain',
    CUSTOMER_NOTIFICATIONS : 'Customer Notifications',
    CUSTOMER_PORTAL        : 'Customer Portal',
    CUSTOMERS              : 'Unlimited Customers',
    DIRECT_DEBIT           : 'Direct Debit',
    DOCUMENTS              : 'Documents',
    EXPENSES               : 'Expenses',
    LOWEST_SMS_COST        : 'Lowest SMS Cost',
    LOYALTY_CARDS          : 'Loyalty Cards',
    REFER_FRIEND           : 'Refer A Friend',
    REVIEWS                : 'Reviews',
    ROUNDS                 : 'Unlimited Rounds',
    ROUTE_OPTIMISATION     : 'Route Optimisation',
    SAVED_REPLIES          : 'Saved Replies',
    SAVED_SEARCHES         : 'Saved Searches',
    SMS_CUSTOM_NAME        : 'SMS Custom Name',
    TAGS                   : 'Customer Tags',
    VERIFICATION           : 'Verification',
    WEEK_PLANNER           : 'Calendar Planner',
};

const unreleased = [
    // 'WEEK_PLANNER',
    // 'SAVED_REPLIES',
    // 'AI_ASSISTANT',
    'AUTO_REPLY',
    'VERIFICATION',
    'REVIEWS',
    'REFER_FRIEND',
    // 'LOYALTY_CARDS',
    // 'DOCUMENTS',
    // 'CUSTOM_DOMAIN',
    // 'ADDITIONAL_USERS',
    // 'BROADCASTS',
    'ATTACHMENTS',
];

const hidden = [
    'VERIFICATION',
    'AUTO_REPLY',
    // 'CUSTOM_DOMAIN',
];

const descriptions = {
    'PRO': 'Perfect for businesses on the rise, looking to boost their performance.',
    'ADVANCED': 'Great for businesses that are growing and need to get more organized.',
    'STARTER': 'Ideal for small businesses with not too much work to handle.',
    'FREE': 'Good if you\'re just starting out.',
    // Legacy plans
    // 'STANDARD': 'Great for businesses that are growing and need to get more organized.',
    // 'BASIC': 'Ideal for small businesses with not too much work to handle.',
}

const usePlans = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'plans',
        stateKey: 'plans',
        fetchData: async () => API.get('/balance/plans'),
        defaultLoadingError: 'Sorry, there was an error loading plans.',
    })
}

const useUnavailableFeatureMessage = (feature) => {
    const titles = {
        // AUTO_REPLY: '',
        // BASIC_WEBSITE: '',
        // DIRECT_DEBIT: '',
        // LOWEST_SMS_COST: '',
        // REFER_FRIEND: '',
        // REVIEWS: '',
        // VERIFICATION: '',
        ADDITIONAL_USERS: 'additional users aren\'t',
        ADVANCED_SCHEDULING: 'advanced scheduling isn\'t',
        AI_ASSISTANT: 'the AI assistant isn\'t',
        ATTACHMENTS: 'attachments aren\'t',
        BANK_RECONCILIATION: 'bank reconciliation isn\'t',
        CARDS_PAYMENTS: 'card payments aren\'t',
        CUSTOM_DOMAIN: 'custom domains aren\'t',
        CUSTOMER_NOTIFICATIONS: 'customer notifications aren\'t',
        CUSTOMER_PORTAL: 'the customer portal isn\'t',
        EXPENSES: 'expenses aren\'t',
        LOYALTY_CARDS: 'loyalty cards aren\'t',
        ROUNDS: 'rounds aren\'t',
        ROUTE_OPTIMISATION: 'route optimisation isn\'t',
        SAVED_REPLIES: 'saved replies aren\'t',
        SMS_CUSTOM_NAME: 'SMS custom names aren\'t',
        TAGS: 'tags aren\'t',
        WEEK_PLANNER: 'the calendar planner isn\'t',
    };

    const title = titles[feature] ?? 'this feature isn\'t';

    return `Sorry, ${title} available on your current plan.`;
}

export {
    features,
    usePlans,
    unreleased,
    hidden,
    descriptions,
    useUnavailableFeatureMessage,
}
